module.exports = new __parcel__URL__("canto-por-travesura.75fc5bef.jpg").toString();